import { render, staticRenderFns } from "./ProvisionCategoriesTable.vue?vue&type=template&id=103a30a0&"
import script from "./ProvisionCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./ProvisionCategoriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports